<template>
	<v-container>
		<v-form v-model="accountforms" ref="accountforms" lazy-validation>
			<div class="popCon_txt">회원 가입을 하시려면 이메일 인증이 필요합니다. <br>회원가입시 사용할 이메일을 입력하신 후 인증메일을 요청해 주세요.</div>
			
			<div class="popCon_input_W100_cov">
				<v-text-field class="inputH48_01 conBstar"
					label="이메일"
					placeholder="이메일 입력"
					v-model="email"
					:rules="rules.emailRules"
					outlined
					dense
					@keyup.enter="isValidForm"
				>
				</v-text-field>
				<v-btn text class="btn17_C01 btn_only_noW" @click="isValidForm">인증메일 발송</v-btn>
			</div>
			<div class="popCon_input_W100_cov txtst_info_gray row_mb-40">- 수신한 메일에서 [이메일 인증 확인] 버튼 클릭 후 [인증완료] 버튼을 클릭하면 회원가입을 진행할 수 있습니다.</div>
		</v-form>
		<v-card-actions class="justify-center signup_btnCon">
		<v-btn outlined class="btn19_00 btnC_01 btn_bottom_W314" @click="submitNext">인증완료</v-btn>
		</v-card-actions>
		<v-dialog title="인증메일 발송 안내" v-model="dialogVisible" width="472" append-to-body id="popStyle02">
      <v-card id="popStyle02" class="popW472">
        <!--<v-btn fab class="popBtnClose"></v-btn>-->
        <v-card-text>
          <v-row no-gutters class="justify-center row_mb-20">입력하신 이메일 주소로 인증 메일이 발송되었습니다.</v-row>
          <v-row no-gutters class="justify-center row_mb-20 fc_C03">{{ accountform.email }}</v-row>
          <v-row no-gutters class="justify-center row_mb-40 txtst_info_gray">- 수신하신 인증 메일에서 [이메일 인증 확인]을 클릭해 주세요.</v-row>
        </v-card-text>
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
          <v-btn outlined class="btn19_00 btnC_01 btn_bottom_W314" @click="dialogVisible = false">확인</v-btn>
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
    </v-dialog>
		<s-confirm ref="confirm"></s-confirm>
    <s-loading ref="loading"></s-loading>
	</v-container>
	
</template>
<script>

import { requestAuthmail, isCheckAuthKey } from '@/api/join'
export default {
  name: 'certification',
  data () {
    return {
      dialogVisible: false,
      input_email: '',
      accountform: {
        auth_key: '',
        email: ''
			},
			rules: {
				emailRules: [
					v => !!v || '이메일을 입력해 주세요.',
					v => /.+@.+\..+/.test(v) || '이메일 형식을 확인 해주세요.',
				]
			}
    }
  },
  created () {
    this.track()
    // console.log('created - org_join')
    if (this.$store.state.user.username !== '') {
			this.$refs.confirm.open('confirm', '회원가입', '로그인 사용자입니다. 로그아웃 후 이용하세요').then(() => {
				this.$router.push('/')
			})
    }
  },
  methods: {
    track () {
      this.$gtag.pageview({
        page_path: '/certification'
      })
    },
    isValidForm () {
      if (this.email === '') {
				this.$refs.confirm.open('alert', '회원가입', '인증받을 이메일을 입력해 주세요.')
      } else {
				var validate = this.$refs.accountforms.validate()
				if (validate) {
					this.accountform.email = this.email
					this.send_email()
				} else {
					return false
				}
      }
    },
    cancelAlert (msg) {
      this.$alert(msg, '', {
        confirmButtonText: '확인',
        showClose: false,
        callback: action => {
        }
      })
    },
    mailDoneAlert () {
      this.dialogVisible = true
    },
    testing () {
      /* debug code - start */
      this.accountform.auth_key = 'b02zizLG5qd9fEU7BQmXyMUq7hcl1MFoBAlasRXe2dhuiEkfHI'
      this.input_email = 'thecsy2@gmail.com'
      this.accountform.email = 'thecsy2@gmail.com'
      this.$router.push({
        name: 'accept_terms',
        params: this.accountform
      })
      /* debug code - end */
    },
    submitNext () {
			this.$refs.loading.start('인증 확인 중')
      this.$nextTick(() => {
        isCheckAuthKey(JSON.stringify({ auth_key: this.accountform.auth_key, email: this.input_email })).then(Response => {
          if (Response.rdata.rcode === 20000) {
            this.$refs.loading.end()
						this.$emit('certEvent', this.accountform)
          } else {
            this.$refs.loading.end()
            this.$refs.confirm.open('alert', '회원가입', Response.rdata.message)
          }
        })
      })
    },
    send_email () {
			this.$refs.loading.start('메일 전송 요청 중')
      this.$nextTick(() => {
        requestAuthmail(JSON.stringify({ user: this.accountform })).then(Response => {
          setTimeout(() => {
            if (Response.rdata.rcode === 20000) {
              this.$refs.loading.end()
              console.log(this.accountform.auth_key)
              this.accountform.auth_key = Response.rdata.user.authKey
							this.accountform.email = Response.rdata.user.userEmail
              this.mailDoneAlert()
            } else if(Response.rdata.rcode === 30000) {
              this.$router.push({ name: 'changeMember', params: { email: this.email } })
            } else {
							this.$refs.loading.end()
							this.$refs.confirm.open('alert', '회원가입', Response.rdata.message)
            }
          }, 5000)
        })
      })
    }
  }
}

</script>
<style scoped>
</style>